import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  navViewTrip,
  navViewEvent,
  navViewEventInfo,
} from 'redux/actions'
import {
  appMode,
  selectedTripId,
  selectedTripData,
  selectedEventData,
  selectedEventNextEventId,
  selectedEventNextEvent,
  selectedEventPreviousEventId,
  selectedEventPreviousEvent,
  selectedEventInfoDisplayed,
  addingTrip,
  editingTrip,
  currentEventId,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = state => ({
  appMode: appMode(state),
  selectedTripId: selectedTripId(state),
  selectedTripData: selectedTripData(state),
  selectedEventData: selectedEventData(state),
  selectedEventNextEventId: selectedEventNextEventId(state),
  selectedEventNextEvent: selectedEventNextEvent(state),
  selectedEventPreviousEventId: selectedEventPreviousEventId(state),
  selectedEventPreviousEvent: selectedEventPreviousEvent(state),
  selectedEventInfoDisplayed: selectedEventInfoDisplayed(state),
  addingTrip: addingTrip(state),
  editingTrip: editingTrip(state),
  currentEventId: currentEventId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      navViewTrip,
      navViewEvent,
      navViewEventInfo,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/index.js